import Vue from 'vue';

export function getBrandList() {
  return Vue.axios({
    url: '/brand/list',
  });
}

export function getCategoryList() {
  return Vue.axios({
    url: '/category/categoryList',
  });
}

export function importOrExportManagerTask(data) {
  return Vue.axios({
    url: '/product/import/importOrExport/manager/task',
    method: 'post',
    data,
  });
}

export function importTwiceConfirm(data) {
  return Vue.axios({
    url: '/product/import/twice/confirm',
    method: 'post',
    data,
  });
}

export function uploadProductAllUpdate(data) {
  return Vue.axios({
    url: '/product/import/product_all_update',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function uploadProductSomeUpdate(data) {
  return Vue.axios({
    url: '/product/import/product_delta_update',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function uploadProductSomeUpdateSeven(data,url) {
  return Vue.axios({
    url: '/product/import/product_delta_update'+url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function batchPriceImport(data) {
  return Vue.axios({
    url: '/api/updatePrice/import',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function getPriceImportTemplate() {
  return Vue.axios({
    url: '/api/updatePrice/import/template/file',
  });
}

export function productImportTemplate(data) {
  return Vue.axios({
    url: '/product/import/template',
    method: 'post',
    data,
  });
}

export function getDraftsList(data) {
  return Vue.axios({
    url: '/product/manage/drafts/product/list',
    method: 'post',
    data,
  });
}

export function deleteDraft(data) {
  return Vue.axios({
    url: '/product/manage/drafts/product/batchDel',
    method: 'post',
    data,
  });
}

export function exportDraftsProduct(eventType, data) {
  return Vue.axios({
    url: `/product/manage/drafts/export/${eventType}`,
    method: 'post',
    data,
  });
}

export function exportProductExcel(productType, data) {
  return Vue.axios({
    url: `/product/manage/export/excel/${productType}`,
    method: 'post',
    data,
  });
}

export function searchLikeProductList(params) {
  return Vue.axios({
    url: '/product/manage/searchLikeProductList',
    params,
  });
}

export function similarCreateProduct(params) {
  return Vue.axios({
    url: '/product/manage/similarCreateProduct',
    params,
  });
}

export function queryBoutiqueErrorByBoutiqueProductId(params) {
  return Vue.axios({
    url: '/product/manage/drafts/product/queryBoutiqueErrorByBoutiqueProductId',
    params,
  });
}

export function batchUpPirceStatus() {
  return Vue.axios({
    url: '/product/manage/product/getPriceStrategyUpdateState',
  });
}

export function seasonList() {
  return Vue.axios({
    url: '/season/vendor/list',
  });
}

export function getSubVendor() {
  return Vue.axios({
    url: '/vendor/manage/subvendor',
  });
}

export function getProductList(data) {
  return Vue.axios({
    url: '/product/manage/product/list',
    method: 'post',
    data,
  });
}

export function getProductSkuList(data) {
  return Vue.axios({
    url: '/product/manage/product/sku/list',
    method: 'post',
    data,
  });
}

export function exportProduct(eventType, data) {
  return Vue.axios({
    url: `/product/manage/export/${eventType}`,
    method: 'post',
    data,
  });
}

export function batchDeleteProduct(data) {
  return Vue.axios({
    url: '/product/manage/product/batchDel',
    method: 'post',
    data,
  });
}

export function clearManageStock(data) {
  return Vue.axios({
    url: '/stock/manage/expiry/clear',
    method: 'post',
    data,
  });
}

export function clearPriceStrategy(data) {
  return Vue.axios({
    url: '/product/manage/product/clearPriceStrategy',
    method: 'post',
    data,
  });
}

export function checkBatchUpPirce(data) {
  return Vue.axios({
    url: '/product/manage/product/checkBatchUpdatePrice',
    method: 'post',
    data,
  });
}

export function batchUpPirce(data) {
  return Vue.axios({
    url: '/product/manage/product/setPriceStrategy',
    method: 'post',
    data,
  });
}

export function queryStockExpiry(productId) {
  return Vue.axios({
    url: `/stock/manage/expiry/info/${productId}`,
  });
}

export function batchUpdateSkuRetailPrice(data) {
  return Vue.axios({
    url: '/product/manage/batchUpdateRetailPrice',
    method: 'post',
    data,
  });
}

export function batchUpdateSkuPrice(data) {
  return Vue.axios({
    url: '/product/manage/product/batchUpPirce',
    method: 'post',
    data,
  });
}

export function batchUpdateSkuStock(data) {
  return Vue.axios({
    url: '/product/manage/product/batchUpStock',
    method: 'post',
    data,
  });
}

export function addOrCancelPreSale(data) {
  return Vue.axios({
    url: '/product/manage/product/addOrCancelPreSale',
    method: 'post',
    data,
  });
}

export function getProductDetail(params) {
  return Vue.axios({
    url: '/product/manage/product/detail',
    params,
  });
}

export function getSyncRecordByBoutiqueProductId(data) {
  return Vue.axios({
    url: '/product/manage/getSyncRecordByBoutiqueProductId',
    method: 'post',
    data,
  });
}

export function getSyncRecordMessage(params) {
  return Vue.axios({
    url: '/product/manage/getSyncRecordMessage',
    params,
  });
}

export function getChangeFieldList(params) {
  return Vue.axios({
    url: '/product/manage/getChangeFieldList',
    params,
  });
}

export function getUpdateTypeList(params) {
  return Vue.axios({
    url: '/product/manage/getUpdateTypeList',
    params,
  });
}

export function getStandardSizeList() {
  return Vue.axios({
    url: '/size/manage/standard/list',
  });
}

export function getDraft(params) {
  return Vue.axios({
    url: '/product/manage/drafts/product/detail',
    params,
  });
}

export function createProduct(data) {
  return Vue.axios({
    url: '/product/manage/product/save',
    method: 'post',
    data,
  });
}

export function updateProduct(data) {
  return Vue.axios({
    url: '/product/manage/product/update',
    method: 'post',
    data,
  });
}

export function saveDraft(data) {
  return Vue.axios({
    url: '/product/manage/drafts/product/save',
    method: 'post',
    data,
  });
}

export function updateDraft(data) {
  return Vue.axios({
    url: '/product/manage/drafts/product/update',
    method: 'post',
    data,
  });
}

export function draftToProduct(data) {
  return Vue.axios({
    url: '/product/manage/drafts/product/updateSketchAndCreateProduct',
    method: 'post',
    data,
  });
}

export function searchProductListByDesignerId(data) {
  return Vue.axios({
    url: '/product/manage/searchProductListByDesignerId',
    method: 'post',
    data,
  });
}

export function searchProductListByCategoryId(data) {
  return Vue.axios({
    url: '/product/manage/searchProductListByCategoryId',
    method: 'post',
    data,
  });
}

export function getSizeStandardList(params) {
  return Vue.axios({
    url: '/size/manage/getSizeStandardList',
    params,
  });
}

export function getSizeListByPackageSizeId(params) {
  return Vue.axios({
    url: '/size/manage/getSizeListByPackageSizeId',
    params,
  });
}

export function copyCreateProduct(data) {
  return Vue.axios({
    url: '/product/manage/product/copyCreateProduct',
    method: 'post',
    data,
  });
}

export function getErrorCodeList() {
  return Vue.axios({
    url: '/product/manage/getErrorCodeList',
  });
}

export function selectImportTypeByVendorId() {
  return Vue.axios({
    url: '/product/import/selectImportTypeByVendorId',
  });
}

export function selectImportFileIoByVendorId(params) {
  return Vue.axios({
    url: '/product/import/selectImportFileIoByVendorId',
    params,
    responseType: 'blob',
  });
}

export function uploadSpecificProductAllUpdate(data) {
  return Vue.axios({
    url: '/product/import/ftp/product_all_update',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function uploadSpecificProductSomeUpdate(data) {
  return Vue.axios({
    url: '/product/import/ftp/product_delta_update',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function updateBlockedStock(data) {
  return Vue.axios({
    url: '/stock/manage/update/blocked/stock',
    method: 'post',
    data,
  });
}

export function getProductSKUTotal(data) {
  return Vue.axios({
    url: '/product/manage/product/sku/total',
    method: 'post',
    data,
  });
}

export function batchUpdateBlockedStock(data) {
  return Vue.axios({
    url: '/stock/manage/batch/update/blocked/stock',
    method: 'post',
    data,
  });
}
// 列表
export async function stockRuleList(data) {
  return (
    await Vue.axios({
      url: '/block/stock/rule/list',
      method: 'POST',
      data,
    })
  ).data;
}
// 新增
export async function stockRuleBatchSave(data) {
  // eslint-disable-next-line no-return-await
  return await Vue.axios({
    url: '/block/stock/rule/batch/save',
    method: 'POST',
    data,
  });
}
// 更新
export async function stockRuleBatchUpdate(data) {
  // eslint-disable-next-line no-return-await
  return await Vue.axios({
    url: '/block/stock/rule/batch/update',
    method: 'POST',
    data,
  });
}
//  删除

export async function stockRuleDelete(data) {
  // eslint-disable-next-line no-return-await
  return await Vue.axios({
    url: '/block/stock/rule/batch/delete',
    method: 'POST',
    data,
  });
}

export function getImportSupplyPriceList(params) {
  return Vue.axios({
    url: '/price/discount/history',
    params,
  });
}

export function checkImportSupplyPrice() {
  return Vue.axios({
    url: `/price/discount/import/flag?r=${Math.random()}`,
  });
}

export function uploadImportSupplyPrice(params) {
  return Vue.axios({
    url: '/price/discount/import',
    params,
  });
}

export function getDiscountSecondCategoryList() {
  return Vue.axios({
    url: '/price/discount/list/second/category',
  });
}

export function getDiscountDaysList() {
  return Vue.axios({
    url: '/price/discount/list/stage/days',
  });
}

export function getDiscountList() {
  return Vue.axios({
    url: '/price/discount/list',
  });
}

export function saveDiscountOnSupplyPrice(data) {
  return Vue.axios({
    url: '/price/discount/update/sku/price/rule',
    method: 'post',
    data,
  });
}

export function validProductSizes(data) {
  return Vue.axios({
    url: '/product/manage/validate/size',
    method: 'post',
    data,
  });
}

export function getRuleDiscountTypeList() {
  return Vue.axios({
    url: '/v2/base/price/list/type',
  });
}

export function getRuleDiscountList() {
  return Vue.axios({
    url: '/v2/base/price/list/discount',
  });
}

export function saveRuleDiscountOnSupplyPrice(data) {
  return Vue.axios({
    url: '/v2/base/price/edit/discount',
    method: 'post',
    data,
  });
}

export function draftsProductMarkTag(data) {
  return Vue.axios({
    url: '/product/manage/drafts/product/mark/tag',
    method: 'post',
    data,
  });
}

export function getProductPoolConfig(params) {
  return Vue.axios({
    url: '/im/productPool/config/get',
    params,
  });
}

export function getProductPoolSPUList(params) {
  return Vue.axios({
    url: '/im/productPool/spu/info',
    params,
  });
}

export function getProductPoolStandardSize(params) {
  return Vue.axios({
    url: '/im/productPool/standard/size',
    params,
  });
}

export function createProductFromProductPool(data) {
  return Vue.axios({
    url: '/im/productPool/spu/create/product',
    method: 'post',
    data,
  });
}

export function getPortalSKUDisplay(data, statisticsType) {
  return Vue.axios({
    url: `/portal/sku/display/page?statisticsType=${statisticsType}`,
    method: 'post',
    data,
  });
}

export function exportPortalSKUDisplay(data, statisticsType) {
  return Vue.axios({
    url: `/portal/sku/display/export?statisticsType=${statisticsType}`,
    method: 'post',
    data,
  });
}

export function exportPortalSKUDisplayResult() {
  return Vue.axios({
    url: '/portal/sku/display/export/result',
  });
}

export function viewPortalSKUDisplayCSV() {
  return Vue.axios({
    url: '/portal/sku/display/viewCsv',
  });
}

export function getSpecialProductList(data) {
  return Vue.axios({
    url: '/price/discount/special-product/list',
    method: 'post',
    data,
  });
}

export function deletetSpecialProduct(data) {
  return Vue.axios({
    url: '/price/discount/special-product/delete',
    method: 'post',
    data,
  });
}

export function importSpecialProduct(data) {
  return Vue.axios({
    url: '/price/discount/special-product/import',
    method: 'post',
    data,
  });
}

export function exportSpecialProduct(params) {
  return Vue.axios({
    url: '/price/discount/special-product/export',
    params,
  });
}

export function getWholesaleList(data) {
  return Vue.axios({
    url: '/wholesale/manage/list',
    method: 'post',
    data,
  });
}

export function createWholesale(data) {
  return Vue.axios({
    url: '/wholesale/manage/create',
    method: 'post',
    data,
  });
}

export function getWholesaleDetail(params) {
  return Vue.axios({
    url: '/wholesale/manage/detail',
    params,
  });
}

export function updateWholesale(data) {
  return Vue.axios({
    url: '/wholesale/manage/update',
    method: 'post',
    data,
  });
}

export function getWholesaleUserList(params) {
  return Vue.axios({
    url: '/wholesale/manage/user/list',
    params,
  });
}


export function getWholesaleValidList(params) {
  return Vue.axios({
    url: '/wholesale/manage/valid/list',
    params,
  });
}

export function getMadeInStandardList(params) {
  return Vue.axios({
    url: '/madeIn/standard/list',
    params,
  });
}

export function getWholesaleBusinessList(params) {
  return Vue.axios({
    url: 'wholesale/manage/business/list',
    params,
  });
}
